import * as favorites from './favorites'
import * as filters from './filters'
import * as message from './message'
import * as playlist from './playlist'
import * as settings from './settings'
import * as sync from './sync'
import * as update from './update'

const slices = [favorites, filters, message, playlist, settings, sync, update]

export default slices
